import { submitPaymentUseCase } from "./submitPaymentCase";
import { findFirst } from "../../../../../../../../../utils/arrays";
import { getPaymentOptionTypeFromId, getUngranularPaymentType } from "./utils";
var isButtonDisabled = function isButtonDisabled(state) {
  var isPhoneFieldInvalid = !state.phoneInput.value || !!state.phoneInput.errorMessage;
  var isSumFieldInvalid = !state.sumInput.value || !!state.sumInput.errorMessage;
  return !!state.submitButton.disabled || state.isLoading || !!state.isProcessing || isPhoneFieldInvalid || isSumFieldInvalid || !state.selectedPaymentId;
};
export var getMapStateToPaymentButtonProps = function getMapStateToPaymentButtonProps(_ref) {
  var getContent = _ref.getContent,
    submitPayment = _ref.submitPayment,
    getIsBeelineError = _ref.getIsBeelineError,
    getIsMobile = _ref.getIsMobile,
    getUserAccountInfo = _ref.getUserAccountInfo;
  return function (getState, setState) {
    var _findFirst, _texts$paymentId;
    var state = getState();
    var paymentId = (_findFirst = findFirst([state.selectedPaymentId && getUngranularPaymentType(getPaymentOptionTypeFromId(state.selectedPaymentId))])) !== null && _findFirst !== void 0 ? _findFirst : 'default';
    var texts = getContent().submitButtonTexts;
    return {
      children: state.isLoading ? '' : (_texts$paymentId = texts[paymentId]) !== null && _texts$paymentId !== void 0 ? _texts$paymentId : texts.default,
      disabled: isButtonDisabled(state),
      onClick: function onClick() {
        submitPaymentUseCase({
          getContent: getContent,
          submitPayment: submitPayment,
          getIsBeelineError: getIsBeelineError,
          getIsMobile: getIsMobile,
          getUserAccountInfo: getUserAccountInfo
        })(getState, setState).catch(console.error);
      }
    };
  };
};